import { render, staticRenderFns } from "./userTestList.vue?vue&type=template&id=7056433e&"
import script from "./userTestList.vue?vue&type=script&lang=js&"
export * from "./userTestList.vue?vue&type=script&lang=js&"
import style0 from "./userTestList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports